import { IconHighlightedSizeType } from '@kubit/web-ui-components/iconHighlighted/types';
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { ProductCardDecorativeElementTypeEnum } from '../../../../../components/productCard/types/decorativeElement';
import { IconHighlightedVariantType } from '../iconHighlighted/variants';
import { TextVariantType } from '../text/variants';
export const commonStyles = (FOUNDATIONS, VARIANT_TOKENS) => ({
    container: {
        border_radius: FOUNDATIONS.radius_comp_content_productcard_radiussize,
        border_width: FOUNDATIONS.border_25,
        border_style: 'solid',
        border_color: FOUNDATIONS.color_neutral_border_160,
        width: '100%',
        background_color: FOUNDATIONS.color_neutral_bg_375,
        overflow: 'hidden',
        display: 'flex',
        [DeviceBreakpointsType.DESKTOP]: {
            min_width: FOUNDATIONS.size_1500,
        },
        ...VARIANT_TOKENS.container,
    },
    decorativeModule: {
        flex_shrink: '0',
        width: FOUNDATIONS.size_350,
        [DeviceBreakpointsType.MOBILE]: {
            width: FOUNDATIONS.size_200,
        },
        ...VARIANT_TOKENS.decorativeModule,
    },
    decorativeElement: {
        [ProductCardDecorativeElementTypeEnum.ICON_HIGHLIGHTED]: {
            color: FOUNDATIONS.color_comp_resources_iconhighlighted_square_icon,
            variant: IconHighlightedVariantType.SQUARE,
            size: IconHighlightedSizeType.EXTRA_SMALL,
            ...VARIANT_TOKENS.decorativeElement?.ICON_HIGHLIGHTED,
        },
        [ProductCardDecorativeElementTypeEnum.ILLUSTRATION]: {
            width: FOUNDATIONS.size_950,
            [DeviceBreakpointsType.MOBILE]: {
                width: FOUNDATIONS.size_475,
            },
            ...VARIANT_TOKENS.decorativeElement?.ILLUSTRATION,
        },
    },
    infoContainer: {
        flex_grow: '1',
        display: 'flex',
        flex_direction: 'column',
        overflow: 'hidden',
        // we do not put a padding for the whole container because we need to put padding in columnContainer, and decorativeElementContainer
        // so focus visible is entirely seen for the link and optionIconButton even in very narrow screens. This is a workaround for the focus visible
        padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_300}`,
        [DeviceBreakpointsType.MOBILE]: {
            padding: FOUNDATIONS.spacing_00,
        },
        ...VARIANT_TOKENS.infoContainer,
    },
    topContainer: {
        display: 'flex',
        width: '100%',
        justify_content: 'space-between',
        flex: 1,
        gap: FOUNDATIONS.spacing_300,
        ...VARIANT_TOKENS.topContainer,
    },
    topLeftInfoContent: {
        display: 'flex',
        width: '100%',
        flex: 1,
        [DeviceBreakpointsType.MOBILE]: {
            padding_left: FOUNDATIONS.spacing_00,
            flex_direction: 'column',
            justify_content: 'center',
            gap: FOUNDATIONS.spacing_250,
        },
        ...VARIANT_TOKENS.topLeftInfoContent,
    },
    optionButtonContainer: {
        padding_top: FOUNDATIONS.spacing_300,
        ...VARIANT_TOKENS.optionButtonContainer,
    },
    decorativeElementContainer: {
        display: 'flex',
        align_items: 'flex-start',
        justify_content: 'space-between',
        padding_top: FOUNDATIONS.spacing_300,
        [DeviceBreakpointsType.MOBILE]: {
            padding_top: FOUNDATIONS.spacing_250,
            padding_left: FOUNDATIONS.spacing_250,
            padding_right: FOUNDATIONS.spacing_250,
        },
        ...VARIANT_TOKENS.decorativeElementContainer,
    },
    titleContainer: {
        display: 'flex',
        align_items: 'center',
        gap: FOUNDATIONS.spacing_150,
        cursor: 'pointer',
        ...VARIANT_TOKENS.titleContainer,
    },
    title: {
        color: FOUNDATIONS.color_neutral_font_50,
        font_variant: TextVariantType.FONT_TITLE_50,
        [DeviceBreakpointsType.MOBILE]: {
            font_variant: TextVariantType.FONT_PARAGRAPH_100,
            overflow: 'hidden',
            word_break: 'break-all',
            white_space: 'normal',
            display: '-webkit-box',
            webkit_line_clamp: '2',
            webkit_box_orient: 'vertical',
        },
        ...VARIANT_TOKENS.title,
    },
    titleIcon: {
        color: FOUNDATIONS.color_neutral_icon_onsurface_50,
        backgroundColor: FOUNDATIONS.color_neutral_bg_onsurface_100,
    },
    tagContainer: {
        display: 'flex',
        align_items: 'center',
        ...VARIANT_TOKENS.tagContainer,
    },
    holder: {
        color: FOUNDATIONS.color_neutral_font_50,
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        overflow: 'hidden',
        white_space: 'nowrap',
        text_overflow: 'ellipsis',
        [DeviceBreakpointsType.MOBILE]: {
            word_break: 'break-all',
            white_space: 'normal',
            display: '-webkit-box',
            webkit_line_clamp: '2',
            webkit_box_orient: 'vertical',
        },
        ...VARIANT_TOKENS.holder,
    },
    centerInfoContainer: {
        margin_top: FOUNDATIONS.spacing_300,
        margin_bottom: FOUNDATIONS.spacing_250,
        ...VARIANT_TOKENS.centerInfoContainer,
    },
    bottomContainer: {
        display: 'grid',
        grid_template_columns: '1f auto',
        align_items: 'center',
        column_gap: FOUNDATIONS.spacing_300,
        row_gap: FOUNDATIONS.spacing_250,
        padding_bottom: FOUNDATIONS.spacing_300,
        [DeviceBreakpointsType.MOBILE]: {
            grid_template_columns: '1fr 1fr',
            column_gap: FOUNDATIONS.spacing_250,
            row_gap: FOUNDATIONS.spacing_100,
            padding_left: FOUNDATIONS.spacing_250,
            padding_right: FOUNDATIONS.spacing_250,
            padding_bottom: FOUNDATIONS.spacing_250,
        },
        ...VARIANT_TOKENS.bottomContainer,
    },
    footerLeftTopTextContainer: {
        grid_column: '1 / 2',
        grid_row: '1 / 2',
        ...VARIANT_TOKENS.footerLeftTopTextContainer,
    },
    footerRightTopTextContainer: {
        grid_column: '2 / 3',
        grid_row: '1 / 2',
        ...VARIANT_TOKENS.footerRightTopTextContainer,
    },
    footerLeftBottomTextContainer: {
        grid_column: '1 / 2',
        grid_row: '2 / 3',
        ...VARIANT_TOKENS.footerLeftBottomTextContainer,
    },
    footerRightBottomTextContainer: {
        grid_column: '2 / 3',
        grid_row: '2 / 3',
        ...VARIANT_TOKENS.footerRightBottomTextContainer,
    },
    footerLeftTopText: {
        color: FOUNDATIONS.color_neutral_font_50,
        font_variant: TextVariantType.FONT_PARAGRAPH_50,
        overflow: 'hidden',
        white_space: 'nowrap',
        text_overflow: 'ellipsis',
        [DeviceBreakpointsType.MOBILE]: {
            font_variant: TextVariantType.FONT_PARAGRAPH_500,
            word_break: 'break-all',
            white_space: 'normal',
            display: '-webkit-box',
            webkit_line_clamp: '2',
            webkit_box_orient: 'vertical',
        },
        ...VARIANT_TOKENS.footerLeftTopText,
    },
    footerLeftBottomText: {
        color: FOUNDATIONS.color_neutral_font_50,
        font_variant: TextVariantType.FONT_PARAGRAPH_50,
        overflow: 'hidden',
        white_space: 'nowrap',
        text_overflow: 'ellipsis',
        [DeviceBreakpointsType.MOBILE]: {
            font_variant: TextVariantType.FONT_PARAGRAPH_500,
            word_break: 'break-all',
            white_space: 'normal',
            display: '-webkit-box',
            webkit_line_clamp: '2',
            webkit_box_orient: 'vertical',
        },
        ...VARIANT_TOKENS.footerLeftBottomText,
    },
    footerRightTopText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_100,
        text_align: 'right',
        white_space: 'nowrap',
        [DeviceBreakpointsType.MOBILE]: {
            font_variant: TextVariantType.FONT_PARAGRAPH_400,
            overflow: 'hidden',
            text_overflow: 'ellipsis',
            word_break: 'break-all',
            white_space: 'normal',
            display: '-webkit-box',
            webkit_line_clamp: '2',
            webkit_box_orient: 'vertical',
        },
        ...VARIANT_TOKENS.footerRightTopText,
    },
    footerRightBottomText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_100,
        text_align: 'right',
        white_space: 'nowrap',
        [DeviceBreakpointsType.MOBILE]: {
            font_variant: TextVariantType.FONT_PARAGRAPH_400,
            overflow: 'hidden',
            text_overflow: 'ellipsis',
            word_break: 'break-all',
            white_space: 'normal',
            display: '-webkit-box',
            webkit_line_clamp: '2',
            webkit_box_orient: 'vertical',
        },
        ...VARIANT_TOKENS.footerRightBottomText,
    },
    topInfoContainer: {
        display: 'flex',
        flex: 1,
        overflow: 'hidden',
        ...VARIANT_TOKENS.topInfoContainer,
    },
    lineSeparatorVariant: 'DECORATIVE_HORIZONTAL',
    helpText: {
        color: FOUNDATIONS.color_neutral_font_50,
        font_variant: TextVariantType.FONT_PARAGRAPH_500,
        overflow: 'hidden',
        white_space: 'nowrap',
        text_overflow: 'ellipsis',
        [DeviceBreakpointsType.MOBILE]: {
            word_break: 'break-all',
            white_space: 'normal',
            display: '-webkit-box',
            webkit_line_clamp: '2',
            webkit_box_orient: 'vertical',
        },
        ...VARIANT_TOKENS.helpText,
    },
    titleAndTagContainer: {
        display: 'flex',
        width: '100%',
        gap: FOUNDATIONS.spacing_150,
        align_items: 'center',
        [DeviceBreakpointsType.MOBILE]: {
            flex: 1,
            flex_direction: 'column-reverse',
            align_items: 'flex-start',
        },
        ...VARIANT_TOKENS.titleAndTagContainer,
    },
    columnContainer: {
        display: 'flex',
        flex_direction: 'column',
        justify_content: 'center',
        flex: 1,
        overflow: 'hidden',
        padding_top: FOUNDATIONS.spacing_300,
        padding_left: FOUNDATIONS.spacing_150,
        gap: FOUNDATIONS.spacing_150,
        [DeviceBreakpointsType.MOBILE]: {
            gap: FOUNDATIONS.spacing_150,
            padding_top: FOUNDATIONS.spacing_00,
            padding_right: FOUNDATIONS.spacing_250,
            padding_left: FOUNDATIONS.spacing_250,
        },
        ...VARIANT_TOKENS.columnContainer,
    },
    additionalTextContainer: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
        overflow: 'hidden',
        [DeviceBreakpointsType.MOBILE]: {
            flex: 1,
        },
        ...VARIANT_TOKENS.additionalTextContainer,
    },
    chartLegendContainer: {
        display: 'grid',
        grid_template_columns: '1f auto',
        column_gap: FOUNDATIONS.spacing_300,
        row_gap: FOUNDATIONS.spacing_250,
        padding_bottom: FOUNDATIONS.spacing_300,
        [DeviceBreakpointsType.MOBILE]: {
            padding_left: FOUNDATIONS.spacing_250,
            padding_right: FOUNDATIONS.spacing_250,
            padding_bottom: FOUNDATIONS.spacing_250,
            grid_template_columns: '1fr 1fr',
            column_gap: FOUNDATIONS.spacing_250,
            row_gap: FOUNDATIONS.spacing_100,
        },
        ...VARIANT_TOKENS.chartLegendContainer,
    },
    leftChartLegend: {
        grid_column: '1 / 2',
        grid_row: '1 / 2',
        ...VARIANT_TOKENS.leftChartLegend,
    },
    rightChartLeged: {
        grid_column: '2 / 3',
        grid_row: '1 / 2',
        justify_content: 'flex-end',
        ...VARIANT_TOKENS.rightChartLeged,
    },
});
//# sourceMappingURL=commonStyles.js.map